import { render, staticRenderFns } from "./StoreAssetCollection.vue?vue&type=template&id=1c5456ea&scoped=true"
import script from "./StoreAssetCollection.vue?vue&type=script&lang=js"
export * from "./StoreAssetCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5456ea",
  null
  
)

export default component.exports